import { createSlice } from "@reduxjs/toolkit";
import {
  FETCH_LAYERS_START,
  FETCH_LAYERS_SUCCESS,
  FETCH_LAYERS_FAILURE,
} from "state/types/actionTypes";

const initialState = {
  layers: [],
  loading: false,
  error: null,
};

const layersSlice = createSlice({
  name: "layers",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(FETCH_LAYERS_START, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(FETCH_LAYERS_SUCCESS, (state, action) => {
        state.layers = action.payload;
        state.loading = false;
      })
      .addCase(FETCH_LAYERS_FAILURE, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const layersReducer = layersSlice.reducer;
